module.exports = __webpack_public_path__ + "static/media/rsyw-text-mock.97228126.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rsyw-text-mock.png
// module id = 199
// module chunks = 0